import styled from "styled-components";

// .authentication-container{
//     display: flex;
//     width: 900px;
//     justify-content: space-between;
//     margin: 30px auto;
// }
export const AuthContainer = styled.div`
display: flex;
width: 900px;
justify-content: space-between;
margin: 30px auto;
`